import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import DeviationDumbView from '../../../Dumbo';
import FolderRibbon from '../../../../Primitives/FolderRibbon';
import s from '../ShopThumb.scss';
var padding = parseInt(s['folder-thumb-padding']);
var FolderContent = function (_a) {
    var folder = _a.folder, width = _a.width, height = _a.height;
    var deviation = folder.thumb;
    var isEmpty = !deviation;
    var thumbWidth = width - padding * 2;
    var thumbHeight = height - padding;
    return (React.createElement("a", { className: classnames(s['thumb'], s['thumb-folder']), href: Url.userGalleryLink({
            username: folder.owner.username,
            gallectionType: folder.type,
            folderId: folder.folderId,
            folderName: folder.name,
        }) },
        deviation ? (React.createElement(DeviationDumbView, { deviation: deviation, width: thumbWidth, height: thumbHeight })) : (React.createElement("div", { className: s['empty'], style: { width: thumbWidth, height: thumbHeight } })),
        !isEmpty && React.createElement("div", { className: s['thumb-overlay'] }),
        !isEmpty && React.createElement("div", { className: s['thumb-overlay-top'] }),
        React.createElement(FolderRibbon, { premiumFolderData: folder.premiumFolderData, className: s['folder-badge'] })));
};
FolderContent.displayName = 'FolderContent';
export default FolderContent;
//# sourceMappingURL=FolderContent.js.map